import Splash from "../screens/splash/Splash";
import {useVscContext} from "./VscReactContext";


const VscSplashImage: React.FC<{image:string, url:string}> = (props) => {
    const vscContext = useVscContext();

    return <Splash image={vscContext.getHtmlContentUri(props.image)} url={props.url} />
}
export default VscSplashImage;